import urlJoin from 'url-join'
import qs from 'qs'

const tokenBase = {
  get isExpired() {
    return this.expiresAt * 1000 < Date.now()
  }
}

const makeToken = token => Object.assign(Object.create(tokenBase), token)

export function redirectForToken(config) {
  let href = urlJoin(
    config.authorizeUrl,
    '?' +
      qs.stringify({
        ...config.auth
      })
  )
  window.location.href = href
}

export function getTokenIfPresent() {
  let token = parseRedirectToken(window.location.hash)
  if (!token) return null
  // clear the hash (might want to get a stored value in the future)
  window.location.hash = ''
  if (token.error) return token
  token = unpackEncodedToken(token)
  if (!token) return null

  token = makeToken(token)
  if (token.isExpired) return null
  return token
}

function parseRedirectToken(value) {
  if (!value || !value.length) return null
  if (value[0] === '#') value = value.substring(1)
  let token = qs.parse(value)
  if (token.error && token.state === '1')
    return { error: `${token.error}: ${token.error_description}` }

  // Check that this is an oauth redirection, not a normal app route
  if (!token.access_token) return null

  return token
}

function parseJwtPayload(payload) {
  if (!payload || !payload.length) return null
  try {
    return JSON.parse(window.atob(payload))
  } catch (e) {
    return null
  }
}

export function parseJwt(token) {
  if (!token) return null
  let decodedJwt = token.split('.').map(str => parseJwtPayload(str))
  return {
    header: decodedJwt[0],
    payload: decodedJwt[1],
    error: !decodedJwt[0] || !decodedJwt[1] || decodedJwt.length !== 3
  }
}

function unpackEncodedToken(token) {
  if (!token || !token.access_token) {
    return null
  }

  let accessValues = token.access_token.split('.')
  let openIdValues = token.id_token.split('.')
  let accessClaims = parseJwtPayload(accessValues[1])
  let openIdClaims = parseJwtPayload(openIdValues[1])

  return {
    username: accessClaims.username || accessClaims.sub,
    accessToken: token.access_token,
    openIdToken: token.id_token,
    accessClaims,
    openIdClaims
  }
}
